/** The campaign that brought the visitor (UTM, referral code), kept for this browser tab until the
 * sign-up (D-110). Only this tab's session storage: nothing is sent before the sign-up. */

import { campaignFrom } from "@agencyos/core";

const KEY = "academy.campaign";

export interface Campaign {
  utm: Record<string, string>;
  referral: string;
}

export function rememberCampaign(search: string): void {
  const found = campaignFrom(search);
  if (!Object.keys(found.utm).length && !found.referral) return;
  try {
    const previous = readCampaign();
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ utm: { ...previous.utm, ...found.utm }, referral: found.referral || previous.referral }),
    );
  } catch {
    /* private window: the campaign is simply not recorded */
  }
}

export function readCampaign(): Campaign {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as Partial<Campaign>) : {};
    return { utm: parsed.utm ?? {}, referral: parsed.referral ?? "" };
  } catch {
    return { utm: {}, referral: "" };
  }
}
